__turbopack_context__.v({
  "blockBtn": "styles-module__jyDu_q__blockBtn",
  "btnCreate": "styles-module__jyDu_q__btnCreate",
  "header": "styles-module__jyDu_q__header",
});
